export const UNIQUE_COMMITTEE_OFFICES = [
  'PRESIDENT',
  'VICE_PRESIDENT',
  'GENERAL_SECRETARY',
  'JOINT_SECRETARY',
  'TREASURER',
] as const;

export type UniqueCommitteeOffice = (typeof UNIQUE_COMMITTEE_OFFICES)[number];

export const OFFICE_BEARER_LABELS: Record<UniqueCommitteeOffice, string> = {
  PRESIDENT: 'President',
  VICE_PRESIDENT: 'Vice President',
  GENERAL_SECRETARY: 'General Secretary',
  JOINT_SECRETARY: 'Joint Secretary',
  TREASURER: 'Treasurer',
};

export const HOUSE_COMMITTEE_ROLES = [
  ...UNIQUE_COMMITTEE_OFFICES,
  'EXECUTIVE_MEMBER',
] as const;

export type HouseCommitteeRole = (typeof HOUSE_COMMITTEE_ROLES)[number];

export const HOUSE_COMMITTEE_ROLE_LABELS: Record<HouseCommitteeRole, string> = {
  PRESIDENT: 'President / Self',
  VICE_PRESIDENT: 'Vice President',
  GENERAL_SECRETARY: 'General Secretary',
  JOINT_SECRETARY: 'Joint Secretary',
  TREASURER: 'Treasurer',
  EXECUTIVE_MEMBER: 'Executive / Committee member',
};
